import React, { Component } from 'react';

// import './Notes.css';
import ListContactsNotes from './ListContactsNotes';
import EditContactsNote from './EditContactsNote';
import AddContactsNote from './AddContactsNote';
import CompanyContext from '../../auth/CompanyContext';

class ContactsNotesForm extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.state = {
            contactsNotes: [],
            editNoteID: 0
        };
    };

    componentDidMount = () => {
        this.getContactsNotes();
    }

    getContactsNotes = () => {
        // console.log('ContactsNotesForm.js/getContactsNotes()');
        // if (!this.props.editID) return;
        this.props.displayCategories({ target: { value: 27 } });
        fetch('/api/contactsNotes/' + this.props.editID, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    contactsNotes: results.data
                });
            });
    }

    addNote = (date, typeID, notes, cb) => {
        // console.log('ContactsNotesForm.js/addNote (date, typeID, notes)', date, typeID, notes);
        fetch('/api/contactsNotes/', {
            method: 'POST',
            body: JSON.stringify({
                contactGUID: this.props.editID,
                date: date,
                typeID: typeID,
                notes: notes,
                user: this.props.user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (cb) cb();
                this.getContactsNotes();
            });
    }

    editNote = (contactGUID, date, typeID, notes, cb) => {
        // console.log('ContactsNotesForm.js/editNote (contactGUID, date, typeID, notes)', contactGUID, date, typeID, notes);
        fetch('/api/contactsNotes/' + contactGUID, {
            method: 'PUT',
            body: JSON.stringify({
                date: date,
                typeID: typeID,
                notes: notes,
                user: this.props.user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (cb) cb();
                this.getContactsNotes();
                this.setState({
                    editNoteID: 0
                });
            });
    }

    deleteNote = (contactGUID, cb) => {
        // console.log('ContactsNotesForm.js/deleteNote (contactGUID)', contactGUID);
        fetch('/api/contactsNotes/' + contactGUID, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (cb) cb();
                this.getContactsNotes();
                this.setState({
                    editNoteID: 0
                });
            });
    }

    isFormBlank(array) {
        let retBool = true;
        array.forEach(row => {
            if (row.value !== null && row.value !== '') { retBool = false; }
        })
        return retBool;
    }

    handleEditSwap = (id) => {
        this.setState({ editNoteID: id })
    }

    render() {
        return (<>
            <AddContactsNote {...this.props}
                addNote={this.addNote}
                isFormBlank={this.isFormBlank}
            />
            {this.state.contactsNotes.map((row, rowIndex) => (
                <div key={row.id} className='mb-2'>
                    <hr className='border-dark' />
                    {this.state.editNoteID !== row.id ? (
                        <ListContactsNotes {...this.props} row={row}
                            handleEditSwap={this.handleEditSwap}
                        />
                    ) : (
                        <EditContactsNote {...this.props}
                            row={row}
                            handleEditSwap={this.handleEditSwap}
                            editNote={this.editNote}
                            deleteNote={this.deleteNote}
                            isFormBlank={this.isFormBlank}
                        />
                    )
                    }
                </div>
            ))}
        </>
        );

    }

}

export default ContactsNotesForm;
